
import permissionsListRedux from '../../views/list/redux/slice'
import permissionEditRedux from '../../modals/edit/redux/slice'

//export redux objects
export default {
    permissionsListRedux,
    permissionEditRedux
};